import { Config } from "@cleeng/mediastore-sdk";
import { EnvironmentType } from "@features/ottPurchase/types/GetOfferApi";
import { ENVIRONMENT } from "@motain/web-shared-hub/constants";

const PUBLISHER_ID = "831031033";
const PUBLISHER_ID_PRODUCTION = "718480834";

interface SetupConfigParams {
  accessToken: string;
  locale: string;
  redirectUrl: string;
  cancelUrl: string;
  offerId: string;
  env?: EnvironmentType;
}

export const setupConfig = ({
  accessToken,
  locale,
  redirectUrl,
  offerId,
  cancelUrl,
  env = "production",
}: SetupConfigParams) => {
  Config.setEnvironment(env);
  Config.setPublisher(
    env === ENVIRONMENT.PRODUCTION ? PUBLISHER_ID_PRODUCTION : PUBLISHER_ID,
  );
  Config.setJWT(accessToken);
  Config.setRefreshToken(""); // Test if this can be removed
  Config.setLanguage(locale);
  Config.setCheckoutPayPalUrls({
    successUrl: `https://payments.onefootball.com/${locale}/thankyou?env=${env}&redirectUrl=${redirectUrl}&offerId=${offerId}`,
    cancelUrl: `https://payments.onefootball.com${cancelUrl}?env=${env}&redirectUrl=${redirectUrl}&offerId=${offerId}`,
    errorUrl: `https://payments.onefootball.com/${locale}/error-page?env=${env}&redirectUrl=${redirectUrl}&offerId=${offerId}`,
  });
  Config.setEnable3DSRedirectFlow();
};
